// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MajorWishList/ProfessionDetail.less
// module id = 939
// module chunks = 0